var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"nebTree",class:{
    'hasMaxHeight':  _vm.maxHeight !== 'unset'
  },style:({
    maxHeight: _vm.maxHeight,
    minHeight: '40px'
  })},_vm._l((_vm.nodes),function(node){return _c('tree-node',{key:node.value,attrs:{"node":node,"selected":_vm.selected,"selectable":_vm.selectable,"singleSelect":_vm.singleSelect},on:{"nodeClick":_vm.onNodeClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }